import { QuestionType } from '@/domain/impact/impact.entity';
import {
  EnvQuestions,
  EnvQuestionValue,
} from '@/domain/impact-env/entities/question.entity';
import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';
import { ImpactEnvGateway } from '@/domain/impact-env/gateways/impact-env.gateway';

export class ApiImpactEnvFakeGateway implements ImpactEnvGateway {
  answers: EnvQuestions = FAKE_INITIAL_ENV_QUESTIONS;
  responses: EnvQuestionValue[] = FAKE_INITIAL_ENV_RESPONSES;

  async getImpactEnvQuestions(): Promise<EnvQuestions> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    return this.answers;

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async getImpactEnvResponses(): Promise<EnvQuestionValue[]> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    return this.responses;

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async createImpactEnvResponse(
    projectId: number,
    paramId: string,
    value: string,
  ): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    const response: EnvQuestionValue = {
      paramId,
      value,
      id: this.getNewIdAnswer(),
    };
    this.responses = [...this.responses, response];

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  getNewIdAnswer(): number {
    return this.responses.reduce((prev, cur) => Math.max(cur.id, prev), 0) + 1;
  }
  async editImpactEnvResponse(answerId: number, value: string): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    const index = this.responses.findIndex((x) => x.id === answerId);
    this.responses = [...this.responses];
    this.responses[index] = { ...this.responses[index], value: value };

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }
}

const FAKE_INITIAL_ENV_QUESTIONS: EnvQuestions = {
  ENV_1: {
    paramId: 'ENV_1',
    topic: EnvTopic.FOOD_BEVERAGES,
    section: EnvSection.CATERING,
    type: QuestionType.PERCENT_SLIDER,
    title: {
      fr: '% des repas proposés végétariens / végétaliens (PUBLIC)',
      en: '% des repas proposés végétariens / végétaliens (PUBLIC)',
    },
  },
  ENV_5: {
    paramId: 'ENV_5',
    topic: EnvTopic.FOOD_BEVERAGES,
    section: EnvSection.CATERING,
    type: QuestionType.BOOLEAN,
    title: {
      fr: 'Faites-vous signer une charte "restauration durable" à l\'intégralité des prestataires restauration ?',
      en: 'Faites-vous signer une charte "restauration durable" à l\'intégralité des prestataires restauration ?',
    },
  },
  ENV_32: {
    paramId: 'ENV_30',
    topic: EnvTopic.COMMUNICATION,
    section: EnvSection.DIGITAL_COMMUNICATION,
    type: QuestionType.SELECT,
    title: {
      fr: "Votre mise en page est-elle bien adaptée (fonds perdus minimisés, pas d'aplats de couleur, de surlignages…) ?",
      en: "Votre mise en page est-elle bien adaptée (fonds perdus minimisés, pas d'aplats de couleur, de surlignages…) ?",
    },
    options: [
      {
        optionId: 'yes',
        title: {
          fr: 'Oui',
          en: 'Yes',
        },
      },
      {
        optionId: 'no',
        title: {
          fr: 'Non',
          en: 'No',
        },
      },
      {
        optionId: 'nothing',
        title: {
          fr: "je n'imprime rien",
          en: "je n'imprime rien",
        },
      },
    ],
  },
};

const FAKE_INITIAL_ENV_RESPONSES: EnvQuestionValue[] = [
  { id: 0, paramId: 'ENV_1', value: '45' },
];
